import { createGlobalStyle } from 'styled-components';
import { Themes } from '..';
export const GlobalCSS = createGlobalStyle `
    @import url('https://fonts.googleapis.com/css?family=Open+Sans&display=swap');

    body {
      font-family: "Open Sans", Helvetica, Arial;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
      background: ${Themes.mf.tokens.space.primary.regular};
      min-height: 100%;

      html, body, div, span,
          h1, h2, h3, h4, h5, h6, p, blockquote, pre,
          a, abbr, acronym, address, big, cite, code,
          del, dfn, em, img, ins, kbd, q, s, samp,
          small, strike, strong, sub, sup, tt, var,
      b, u, i, center,
          dl, dt, dd, ol, ul, li,
          fieldset, form, label, legend,
          table, caption, tbody, tfoot, thead, tr, th, td,
          article, aside, details, figcaption, footer, header, hgroup,
          menu, nav, output, ruby, section, summary,
          time {
            -webkit-font-smoothing: subpixel-antialiased;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
          }
    }

    html.wf-loading span, html.wf-loading h1, html.wf-loading h2, html.wf-loading h3, html.wf-loading h4, html.wf-loading h5, html.wf-loading h6,
    html.wf-loading p, html.wf-loading blockquote, html.wf-loading pre, html.wf-loading a, html.wf-loading abbr, html.wf-loading address,
    html.wf-loading big, html.wf-loading cite, html.wf-loading code, html.wf-loading em, html.wf-loading small, html.wf-loading strike,
    html.wf-loading strong, html.wf-loading sub, html.wf-loading sup, tt, html.wf-loading b, html.wf-loading u, html.wf-loading i,
    html.wf-loading center, html.wf-loading dl, html.wf-loading dt, html.wf-loading dd, html.wf-loading li, html.wf-loading label,
    html.wf-loading legend, html.wf-loading th, html.wf-loading td, html.wf-loading button
    {
        visibility: hidden;
    }

    input[autocomplete="off"]::-webkit-credentials-auto-fill-button,
    input[autocomplete="off"]::-webkit-contacts-auto-fill-button {
      visibility: hidden;
      display: none !important;
      pointer-events: none;
      height: 0;
      width: 0;
      margin: 0;
    }
    `;
//# sourceMappingURL=globalCSS.js.map